import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Rx';

import { Slug } from 'ng2-slugify';

import { PortService } from '../../_services/port.service';
import { ProjectService } from '../../_services/project.service';
import { AdminService } from '../../_services/admin.service';
@Component({
    selector: 'app-edit-project',
    templateUrl: './edit-project.component.html',
    styleUrls: ['./edit-project.component.less']
})
export class EditProjectComponent implements OnInit {
    private isNaN: Function = Number.isNaN;
    private isInvalidNumber: Function = (num) => {
        return isNaN(num) || num == null;
    };

    private busy: boolean;
    private years = [];
    private project: any = {};

    private portId: number;
    private slug: string;
    private projectId: number;
    private selectedYear: number;
    private mapType: string;

    private pmo: any = {};
    private port: any = {};
    private projectTypes: any = [];
    private projectStatuses: any = [{ Id: 0, Title: 'Bidding', }, { Id: 1, Title: 'On-going' }, { Id: 2, Title: 'Completed'}];

    private minDate: Date;
    private maxDate: Date;

    private projectType: any;
    private projectStatus: any;
    private slugify: Slug;

    private files: any = [];

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private portService: PortService, private projectService: ProjectService, private adminService : AdminService, private snackBar: MatSnackBar) {
        let params = this.activatedRoute.snapshot.params;
        this.slugify = new Slug('');

        this.portId = parseInt(params['portId']);
        this.slug = params['slug'];
        this.projectId = parseInt(params['projectId']);
    }

    ngOnInit() {
        this.busy = true;
        Observable.forkJoin([
                this.adminService.get('projects/types'),
                this.projectService.getProject(this.projectId)
            ])
            .subscribe((response) => {
                let getProjectTypesResponse = response[0];
                let getProjectTypesResult = getProjectTypesResponse.json().Result;
                let projectTypes = getProjectTypesResult.ProjectTypes;
                projectTypes.forEach((type) => {
                    if (type.Color == null) type.Color = '#000000';
                    else type.Color = '#' + type.Color;
                });

                this.projectTypes = projectTypes;

                let getProjectResponse = response[1];
                let getProjectResponseResult = getProjectResponse.json().Result;

                let project = getProjectResponseResult.Project;
                if (project.Facility) {
                    project.Facility.Slug = this.slugify.slugify(project.Facility.Title);
                }

                project.TypeId = project.Type.Id;
                project.Contractor = project.Contractor.Name;

                if (project.BiddedOn) {
                    project.BiddedOn = new Date(project.BiddedOn);
                }

                if (project.NoticeAwardedOn) {
                    project.NoticeAwardedOn = new Date(project.NoticeAwardedOn);
                }

                if (project.EffectiveOn) {
                    project.EffectiveOn = new Date(project.EffectiveOn);
                }

                if (project.ExpiresOn) {
                    project.ExpiresOn = new Date(project.ExpiresOn);
                }

                if (project.TargetCompletedOn) {
                    project.TargetCompletedOn = new Date(project.TargetCompletedOn);
                }

                if (project.ActualCompletedOn) {
                    project.ActualCompletedOn = new Date(project.ActualCompletedOn);
                }

                if (project.Facility == null) {
                    this.selectedYear = project.Year;
                    this.mapType = 'navigation';
                }

                projectTypes.forEach((type) => {
                    if (type.Id == project.Type.Id) {
                        this.projectType = type;
                    }
                });

                this.projectStatus = this.projectStatuses.find((status) => status.Id == project.Status);
                this.project = project;

                this.busy = false;
            });
    }

    getProjectType(id: number) {
        return this.projectTypes.find((type) => type.Id == id);
    }

    getProjectStatus(id: number) {
        return this.projectStatuses.find((status) => status.Id == id);
    }

    editProject() {
        this.busy = true;

        let project: any = Object.assign({}, this.project);
        project.PortId = this.project.Port.Id;
        if (project.Facility) {
            project.FacilityId = this.project.Facility.Id;
        }

        if (project.BiddedOn) {
            project.BiddedOn = project.BiddedOn.toISOString();
        }

        if (project.NoticeAwardedOn) {
            project.NoticeAwardedOn = project.NoticeAwardedOn.toISOString();
        }

        if (project.EffectiveOn) {
            project.EffectiveOn = project.EffectiveOn.toISOString();
        }

        if (project.ExpiresOn) {
            project.ExpiresOn = project.ExpiresOn.toISOString();
        }

        if (project.TargetCompletedOn) {
            project.TargetCompletedOn = project.TargetCompletedOn.toISOString();
        }

        if (project.ActualCompletedOn) {
            project.ActualCompletedOn = project.ActualCompletedOn.toISOString();
        }

        delete project.PortManagementOffice;
        delete project.Port;
        delete project.Facility;
        delete project.Files;
        delete project.Type;
        
        this.projectService.updateProject(project).subscribe((response) => {
            this.busy = false;
            let result = response.json().Result;

            if (result.Project.Id) {
                this.snackBar.open('Project was updated successfully.', null, { duration: 2000 });
                this.router.navigate(['/', this.portId, this.slug, 'projects', this.project.Id]);
            } else {
                this.snackBar.open('Failed to updated project.', null, { duration: 2000 });
            }
        }, (error) => {
            this.busy = false;
            this.snackBar.open('Failed to update project: ' + error.Message, null, { duration: 5000 });
        });
    }

    validateFile($event) {
        let file = this.files.pop();
        this.project.ImagePreview = file;
    }
}



// WEBPACK FOOTER //
// ./Angular/app/project/edit-project/edit-project.component.ts